<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: "App",
  }
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*background-color: #f8fafb;*/
  font-size: 18px !important;

}
html{
  overflow-y: scroll;
}
:root {
  overflow-y: auto;
  overflow-x: hidden;
}
:root body {
  position: absolute;
}
body {
  width: 100vw;
  /*overflow: hidden;*/
}
html,body,#app{
    margin:0;
    height: 100%;
    /*background: #03060E;*/

}


.el-container {
  height: 100%;
}
.el-menu {
  height: 100%;
  border-right: 0 !important;
}

.el-menu-item{
  font-size: 16px !important;
  height: 8% !important;
}
</style>
